import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

const fontSizes = [
  { label: 'Small', value: 14 },
  { label: 'Normal', value: 16 },
  { label: 'Medium', value: 18 },
  { label: 'Large', value: 20 },
  { label: 'XL', value: 22 }
];

export default function FontSizeSelector() {
  const [selectedFontSize, setSelectedFontSize] = useState(18);

  const changeFontSize = (e: any) => {
    const size = e.value;

    setSelectedFontSize(size);
    document.documentElement.style.setProperty("--app-font-size", `${size}px`);
    localStorage.setItem("appFontSize", String(size));

    window.dispatchEvent(new Event("fontSizeChanged"));
  };

  useEffect(() => {
    const savedSize = localStorage.getItem("appFontSize");

    if (savedSize) {
      const size = Number(savedSize);
      setSelectedFontSize(size);
      document.documentElement.style.setProperty("--app-font-size", `${size}px`);
    }
  }, []);

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="font-size-selector" className="font-semibold">
        Font Size:
      </label>

      <Dropdown
        id="font-size-selector"
        value={selectedFontSize}
        options={fontSizes}
        optionLabel="label"
        optionValue="value"
        placeholder="Font Size"
        className="w-8rem"
        onChange={changeFontSize}
      />
    </div>
  );
}